// 全局注册自定义组件，在任何组件中直接使用

export default {
    install: (Vue) => {
        //登录表单组件
        Vue.component("LoginForm", () =>
            import("../components/login_form/LoginForm.vue")
        );
        // 滑动条
        Vue.component("Slider", () => import("../components/slider/Slider.vue"));
        // 首页的新闻公告轮播图
        Vue.component("noticeSwiper", () =>
            import("../components/swiper/noticeSwiper.vue")
        );
        // 首页的示范项目成果list
        Vue.component("SfxList", () => import("../components/list/SfxList.vue"));
        // 首页的示范课堂list
        Vue.component("SfktList", () => import("../components/list/SfktList.vue"));
        
        Vue.component("AbList", () => import("../components/list/abList.vue"));
        // 推荐直播list
        Vue.component("recommentLiveList", () =>
            import("../components/list/recommentLiveList.vue")
        );
        // 直播间讨论list
        Vue.component("LiveRoomDiscussList", () =>
            import("../components/list/LiveRoomDiscussList.vue")
        );
        // 微能力成果详情页list
        Vue.component("abilityList", () =>
            import("../components/list/abilityList.vue")
        );
        // 面包屑
        Vue.component("MyBreadCrumb", () =>
            import("../components/breaadcrumb/MyBreadCrumb.vue")
        );
        // 分页
        Vue.component("Pagination", () =>
            import("../components/pagination/Pagination.vue")
        );
        // 成果详情头部
        Vue.component("AchievementHeader", () =>
            import("../components/achievementDetail/AchievementHeader.vue")
        );
        // 成果详情评论
        Vue.component("Comment", () => import("../components/comment/Comment.vue"));
        // 课程评论
        Vue.component("CourseComment", () =>
            import("../components/comment/CourseComment.vue")
        );
        // 微能力更多列表
        Vue.component("abilityMoreList", () =>
            import("../components/list/abilityMoreList.vue")
        );
        // 整校推进列表
        Vue.component("SchoolAdvanceList", () =>
            import("../components/list/SchoolAdvanceList.vue")
        );
        // 整校推进详情列表
        Vue.component("SchoolDetailList", () =>
            import("../components/list/SchoolDetailList.vue")
        );
        // 示范课堂的公用组件
        Vue.component("CourseCommen", () =>
            import("../components/courseCommen/CourseCommen.vue")
        );
        // 示范项目智能领航list
        Vue.component("ZnlhList", () => import("../components/list/ZnlhList.vue"));
        // 示范项目智能领航main
        Vue.component("SubIntelligentNavigation", () =>
            import("../components/sfAchievementContent/SubIntelligentNavigation.vue")
        );
        // 示范项目跨学科教学骨干教师培养系列main
        Vue.component("SubInterdisciplinary", () =>
            import("../components/sfAchievementContent/SubInterdisciplinary.vue")
        );
        // 个人中心教师菜单栏
        Vue.component("Menu", () => import("../components/menu/Menu.vue"));
        // 个人中心校培菜单栏
        Vue.component("SchoolTrainMenu", () =>
            import("../components/menu/SchoolTrainMenu.vue")
        );
        // 金山云上传
        Vue.component("DcUpload", () =>
            import("../components/dcUpload/src/index.vue")
        );
        // 成果详情内容
        Vue.component("AchievementContent", () =>
            import("../components/achievementDetail/AchievementContent.vue")
        );
        // 非微能力成果认定详情头部
        Vue.component("SfAchievementHeader", () =>
            import("../components/achievementDetail/SfAchievementHeader.vue")
        );
        // 微能力成果认定详情头部
        Vue.component("AbilityAchievementHeader", () =>
            import("../components/achievementDetail/AbilityAchievementHeader.vue")
        );
        // 微能力证书列表
        Vue.component("CartificateList", () =>
            import("../components/list/CartificateList.vue")
        );
        // 搜索
        Vue.component("MySearch", () =>
            import("../components/mysearch/MySearch.vue")
        );
        // 非能力教师认定成果表格
        Vue.component("ConfirmTable", () =>
            import("../components/table/ConfirmTable.vue")
        );
        // 非能力教师直播表格
        Vue.component("ZhiBTable", () =>
            import("../components/table/ZhiBTable.vue")
        );
        // 非能力教师录播表格
        Vue.component("LubTable", () => import("../components/table/LubTable.vue"));
        // 校培训申报表格
        Vue.component("DeClareTable", () =>
            import("../components/table/DeClareTable.vue")
        );
        // 校培训添加微能力表格
        Vue.component("AddAbilityTable", () =>
            import("../components/table/AddAbilityTable.vue")
        );
        // 校培训待评审表格
        Vue.component("WaitJudgeTable", () =>
            import("../components/table/WaitJudgeTable.vue")
        );
        // 校培训能力认定表格
        Vue.component("AbilityConfirmTable", () =>
            import("../components/table/AbilityConfirmTable.vue")
        );
        // 微能力教师成果认定表格
        Vue.component("TinyTable", () =>
            import("../components/table/TinyTable.vue")
        );
        // 校培微能力申报表格
        Vue.component("AreaAbilityTable", () =>
            import("../components/table/AreaAbilityTable.vue")
        );
        // 县培微能力待认定表格
        Vue.component("AreaWaitConfirmTable", () =>
            import("../components/table/AreaWaitConfirmTable.vue")
        );
        // 个人中心公用头部
        Vue.component("PersonalHeader", () =>
            import("../components/personalHeader/PersonalHeader.vue")
        );
        // 校培菜单
        Vue.component("AreaTrainMenu", () =>
            import("../components/menu/AreaTrainMenu.vue")
        );
        // 校培教师个人信息头部
        Vue.component("PersonalHeaderV2", () =>
            import("../components/personalHeader/PersonalHeaderV2.vue")
        );
        // 校培非微能力成果内容表格
        Vue.component("UnAbilityAchievementTable", () =>
            import("../components/table/UnAbilityAchievementTable.vue")
        );
        // 校管理菜单
        Vue.component("SchoolMngMenu", () =>
            import("../components/menu/SchoolMngMenu.vue")
        );
        // 校管理团队表格
        Vue.component("SchoolMngTeamTable", () =>
            import("../components/table/SchoolMngTeamTable.vue")
        );
        // 校管理分配考核人员表格
        Vue.component("SchoolMngFpAssessTable", () =>
            import("../components/table/SchoolMngFpAssessTable.vue")
        );
        // 校管理教师信息技术应用能力等次表格
        Vue.component("SchoolMngTeacherGradeTable", () =>
            import("../components/table/SchoolMngTeacherGradeTable.vue")
        );
        // 校管理项目类别表格
        Vue.component("SchoolMngProjectLbTable", () =>
            import("../components/table/SchoolMngProjectLbTable.vue")
        );
        // 校管理成果管理表格
        Vue.component("SchoolMngAchievementTable", () =>
            import("../components/table/SchoolMngAchievementTable.vue")
        );
        // 校管理教师微能力提升清单表格
        Vue.component("SchoolMngPromoteTable", () =>
            import("../components/table/SchoolMngPromoteTable.vue")
        );
        // 选择参加测评的老师表格
        Vue.component("SchoolMngSelectTestTTable", () =>
            import("../components/table/SchoolMngSelectTestTTable.vue")
        );
        // 教师测评记录表格
        Vue.component("SchoolMngTestRecordTable", () =>
            import("../components/table/SchoolMngTestRecordTable.vue")
        );
        // 校培未购买微能力测评
        Vue.component("SchoolTrainTest", () =>
            import("../views/schoolTrain/SchoolTrainTest.vue")
        );
        // 微能力dialog
        Vue.component("AbilityDetailDialog", () =>
            import("../components/dialog/AbilityDetailDialog.vue")
        );
        // 微能力dialog
        Vue.component("Empty", () =>
            import("../components/empty/Empty.vue")
        );
         // 弹出层Popover
         Vue.component("MyPopover", () =>
         import("../components/MyPopover/MyPopover.vue")
     );
    },
};